var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowsgroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224.303,
    height: 320.453,
    viewBox: "0 0 224.303 320.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrowsgroup",
    transform: "translate(24.207 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_15",
    "data-name": "Polygon 15",
    d: "M30.345,0,60.691,52.586H0Z",
    transform: "translate(147.51 111.637) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_30",
    "data-name": "Polygon 30",
    d: "M4.788,0,9.576,8.379H0Z",
    transform: "translate(45.28 10.789) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_24",
    "data-name": "Polygon 24",
    d: "M30.345,0,60.691,52.586H0Z",
    transform: "translate(147.51 187.619) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_32",
    "data-name": "Polygon 32",
    d: "M9.623,0l9.623,16.668H0Z",
    transform: "translate(170.995 243.961) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_34",
    "data-name": "Polygon 34",
    d: "M11.26,0l11.26,19.5H0Z",
    transform: "translate(169.732 320.453) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_23",
    "data-name": "Polygon 23",
    d: "M30.345,0,60.691,52.586H0Z",
    transform: "translate(14.888 111.637) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_22",
    "data-name": "Polygon 22",
    d: "M30.345,0,60.691,52.586H0Z",
    transform: "translate(129.584 50.946) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_27",
    "data-name": "Polygon 27",
    d: "M17.664,0,35.328,30.611H0Z",
    transform: "translate(49.586 102.061) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_15-2",
    "data-name": "Polygon 15",
    d: "M30.345,0,60.691,52.586H0Z",
    transform: "translate(116.749 104.226) rotate(-30)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_22-2",
    "data-name": "Polygon 22",
    d: "M30.345,0,60.691,52.586H0Z",
    transform: "translate(160.345 58.357) rotate(150)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_15-3",
    "data-name": "Polygon 15",
    d: "M30.345,0,60.691,52.586H0Z",
    transform: "translate(107.786 73.881) rotate(30)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_25",
    "data-name": "Polygon 25",
    d: "M16.531,0,33.061,29.1H0Z",
    transform: "translate(112.373 170.211) rotate(30)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_41",
    "data-name": "Polygon 41",
    d: "M16.531,0,33.061,29.1H0Z",
    transform: "translate(-9.656 48.35) rotate(30)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_22-3",
    "data-name": "Polygon 22",
    d: "M30.345,0,60.691,52.586H0Z",
    transform: "translate(169.308 88.702) rotate(-150)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_31",
    "data-name": "Polygon 31",
    d: "M7.551,0,15.1,12.523H0Z",
    transform: "translate(97.029 243.961) rotate(-150)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_35",
    "data-name": "Polygon 35",
    d: "M6.169,0l6.169,9.76H0Z",
    transform: "translate(96.018 317.55) rotate(-150)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_28",
    "data-name": "Polygon 28",
    d: "M19.984,0,39.969,34.627H0Z",
    transform: "translate(34.614 73.336) rotate(-150)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_29",
    "data-name": "Polygon 29",
    d: "M6.048,0,12.1,10.48H0Z",
    transform: "translate(96.273 15.124) rotate(-150)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_26",
    "data-name": "Polygon 26",
    d: "M13.768,0,27.535,23.575H0Z",
    transform: "translate(97.074 177.69) rotate(-150)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_15-4",
    "data-name": "Polygon 15",
    d: "M30.345,0,60.691,52.586H0Z",
    transform: "translate(107.786 230.212) rotate(30)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_22-4",
    "data-name": "Polygon 22",
    d: "M24.589,0,49.177,42.61H0Z",
    transform: "translate(167.929 233.515) rotate(-150)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_33",
    "data-name": "Polygon 33",
    d: "M5.939,0l5.939,10.836H0Z",
    transform: "translate(162.375 281.289) rotate(-150)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_36",
    "data-name": "Polygon 36",
    d: "M3.866,0,7.733,6.692H0Z",
    transform: "translate(56.584 311.193) rotate(150)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_37",
    "data-name": "Polygon 37",
    d: "M3.866,0,7.733,6.692H0Z",
    transform: "translate(31.135 277.817) rotate(-150)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsgroup);
export default __webpack_public_path__ + "static/media/arrowsgroup.6416ed37ba8752e082647ac2341aae53.svg";
export { ForwardRef as ReactComponent };